unit View.Fs_Prod_SubDepartamentos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls, UUtils,
  UHelperServer, UWeb.Enum;

type
  TFViewFs_Prod_SubDepartamentosEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientFs_Prod_SubDepartamentosGet: TXDataWebClient;
    Fs_Prod_SubDepartamentosDataset: TXDataWebDataSet;
    Fs_Prod_SubDepartamentosDatasetid: TIntegerField;
    Fs_Prod_SubDepartamentosDatasetnome: TStringField;
    Fs_Prod_SubDepartamentosDatasetexcluido: TBooleanField;
    Fs_Prod_SubDepartamentosDatasetinclusao: TDateTimeField;
    Fs_Prod_SubDepartamentosDatasetalteracao: TDateTimeField;
    Fs_Prod_SubDepartamentosDatasetexclusao: TDateTimeField;
    cbExcluido: TDBCheckBox;
    procedure btCancelClick(Sender: TObject);
    [async]
    procedure btSaveClick(Sender: TObject); async;
    procedure XDataClientFs_Prod_SubDepartamentosGetLoad(Response: TXDataClientResponse);
    procedure Fs_Prod_SubDepartamentosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormShow(Sender: TObject);
    procedure ednomeClick(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewFs_Prod_SubDepartamentosEdit: TFViewFs_Prod_SubDepartamentosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewFs_Prod_SubDepartamentosEdit }

procedure TFViewFs_Prod_SubDepartamentosEdit.btSaveClick(Sender: TObject);
begin
  if THelperServer.VerificarCampoVazio(ednome) then
  begin
    TUtils.SetErroClass('lbnome', 'Preencha o nome!');
    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, THelperServer.GetMensagemPadraoSalvar(FInserting))) then
  begin
    if Fs_Prod_SubDepartamentosDataset.State in dsEditModes then
    begin
      Fs_Prod_SubDepartamentosDataset.Post;
      Fs_Prod_SubDepartamentosDataset.ApplyUpdates;
    end
    else
      FShowListProc;
  end;
end;


class function TFViewFs_Prod_SubDepartamentosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewFs_Prod_SubDepartamentosEdit.ednomeClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('lbnome');
end;

procedure TFViewFs_Prod_SubDepartamentosEdit.InsertEntity;
begin
  Fs_Prod_SubDepartamentosDataset.Close;
  Fs_Prod_SubDepartamentosDataset.SetJsonData('{}');
  Fs_Prod_SubDepartamentosDataset.Open;
  Fs_Prod_SubDepartamentosDataset.Insert;
end;

class function TFViewFs_Prod_SubDepartamentosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewFs_Prod_SubDepartamentosEdit(AForm).FInserting := AInserting;
    TFViewFs_Prod_SubDepartamentosEdit(AForm).FId := AId;
    TFViewFs_Prod_SubDepartamentosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewFs_Prod_SubDepartamentosEdit(AForm).InsertEntity
    else
      TFViewFs_Prod_SubDepartamentosEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewFs_Prod_SubDepartamentosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewFs_Prod_SubDepartamentosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Fs_Prod_SubDepartamentosDataset.Connection.Model.DefaultSchema.FindEntityType(
      Fs_Prod_SubDepartamentosDataset.EntitySetName
    )
  );
  XDataClientFs_Prod_SubDepartamentosGet.Get(Fs_Prod_SubDepartamentosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewFs_Prod_SubDepartamentosEdit.WebFormShow(Sender: TObject);
begin
  if FInserting then
    THelperServer.RemoverDiv('campos-controle')
  else
  begin
    if not TUtils.PossuiPermissao(Fs_Prod_SubDepartamentosDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
    begin
      btSave.Enabled := False;
      ednome.Enabled := False;
      cbExcluido.Enabled := False;
    end;
  end;
end;

procedure TFViewFs_Prod_SubDepartamentosEdit.XDataClientFs_Prod_SubDepartamentosGetLoad(Response: TXDataClientResponse);
begin
  Fs_Prod_SubDepartamentosDataset.Close;
  Fs_Prod_SubDepartamentosDataset.SetJsonData(Response.Result);
  Fs_Prod_SubDepartamentosDataset.Open;
  
  Fs_Prod_SubDepartamentosDataset.Edit;  
end;

procedure TFViewFs_Prod_SubDepartamentosEdit.Fs_Prod_SubDepartamentosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, ResolveInfo.Error);
      Fs_Prod_SubDepartamentosDataset.Edit;
      Exit;
    end;
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, THelperServer.GetMensagemPadraoSalvarSucesso(FInserting));
  FShowListProc;
end;

procedure TFViewFs_Prod_SubDepartamentosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewFs_Prod_SubDepartamentosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.fs_prod_subdepartamentos.form.lbid');
  lbnome := TLabel.Create('view.fs_prod_subdepartamentos.form.lbnome');
  lbexcluido := TLabel.Create('view.fs_prod_subdepartamentos.form.lbexcluido');
  lbinclusao := TLabel.Create('view.fs_prod_subdepartamentos.form.lbinclusao');
  lbalteracao := TLabel.Create('view.fs_prod_subdepartamentos.form.lbalteracao');
  lbexclusao := TLabel.Create('view.fs_prod_subdepartamentos.form.lbexclusao');
  btCancel := TButton.Create('view.fs_prod_subdepartamentos.form.btBack');
  btSave := TButton.Create('view.fs_prod_subdepartamentos.form.btSave');
  edid := TDBEdit.Create('view.fs_prod_subdepartamentos.form.edid');
  ednome := TDBEdit.Create('view.fs_prod_subdepartamentos.form.ednome');
  edinclusao := TDBEdit.Create('view.fs_prod_subdepartamentos.form.edinclusao');
  edalteracao := TDBEdit.Create('view.fs_prod_subdepartamentos.form.edalteracao');
  edexclusao := TDBEdit.Create('view.fs_prod_subdepartamentos.form.edexclusao');
  cbExcluido := TDBCheckBox.Create('view.fs_prod_subdepartamentos.form.cbexcluido');
  DataSource := TDataSource.Create(Self);
  Fs_Prod_SubDepartamentosDataset := TXDataWebDataSet.Create(Self);
  Fs_Prod_SubDepartamentosDatasetid := TIntegerField.Create(Self);
  Fs_Prod_SubDepartamentosDatasetnome := TStringField.Create(Self);
  Fs_Prod_SubDepartamentosDatasetexcluido := TBooleanField.Create(Self);
  Fs_Prod_SubDepartamentosDatasetinclusao := TDateTimeField.Create(Self);
  Fs_Prod_SubDepartamentosDatasetalteracao := TDateTimeField.Create(Self);
  Fs_Prod_SubDepartamentosDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientFs_Prod_SubDepartamentosGet := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbExcluido.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Fs_Prod_SubDepartamentosDataset.BeforeLoadDFMValues;
  Fs_Prod_SubDepartamentosDatasetid.BeforeLoadDFMValues;
  Fs_Prod_SubDepartamentosDatasetnome.BeforeLoadDFMValues;
  Fs_Prod_SubDepartamentosDatasetexcluido.BeforeLoadDFMValues;
  Fs_Prod_SubDepartamentosDatasetinclusao.BeforeLoadDFMValues;
  Fs_Prod_SubDepartamentosDatasetalteracao.BeforeLoadDFMValues;
  Fs_Prod_SubDepartamentosDatasetexclusao.BeforeLoadDFMValues;
  XDataClientFs_Prod_SubDepartamentosGet.BeforeLoadDFMValues;
  try
    Name := 'FViewFs_Prod_SubDepartamentosEdit';
    Width := 593;
    Height := 427;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 219;
    lbnome.Width := 31;
    lbnome.Height := 13;
    lbnome.Caption := 'Nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 246;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 273;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 300;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 327;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 367;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancelar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 367;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Salvar';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 5;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 216;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.MaxLength := 50;
    ednome.TabOrder := 6;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    SetEvent(ednome, Self, 'OnClick', 'ednomeClick');
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 270;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 8;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 297;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 9;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 324;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 10;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbExcluido.SetParentComponent(Self);
    cbExcluido.Name := 'cbExcluido';
    cbExcluido.Left := 221;
    cbExcluido.Top := 243;
    cbExcluido.Width := 113;
    cbExcluido.Height := 22;
    cbExcluido.Caption := 'cbExcluido';
    cbExcluido.ChildOrder := 13;
    cbExcluido.HeightPercent := 100.000000000000000000;
    cbExcluido.WidthPercent := 100.000000000000000000;
    cbExcluido.DataField := 'excluido';
    cbExcluido.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Fs_Prod_SubDepartamentosDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Fs_Prod_SubDepartamentosDataset.SetParentComponent(Self);
    Fs_Prod_SubDepartamentosDataset.Name := 'Fs_Prod_SubDepartamentosDataset';
    Fs_Prod_SubDepartamentosDataset.AfterApplyUpdates := Fs_Prod_SubDepartamentosDatasetAfterApplyUpdates;
    Fs_Prod_SubDepartamentosDataset.EntitySetName := 'Fs_Prod_SubDepartamentos';
    Fs_Prod_SubDepartamentosDataset.Connection := DMConnection.ApiConnection;
    Fs_Prod_SubDepartamentosDataset.Left := 176;
    Fs_Prod_SubDepartamentosDataset.Top := 8;
    Fs_Prod_SubDepartamentosDatasetid.SetParentComponent(Fs_Prod_SubDepartamentosDataset);
    Fs_Prod_SubDepartamentosDatasetid.Name := 'Fs_Prod_SubDepartamentosDatasetid';
    Fs_Prod_SubDepartamentosDatasetid.FieldName := 'id';
    Fs_Prod_SubDepartamentosDatasetnome.SetParentComponent(Fs_Prod_SubDepartamentosDataset);
    Fs_Prod_SubDepartamentosDatasetnome.Name := 'Fs_Prod_SubDepartamentosDatasetnome';
    Fs_Prod_SubDepartamentosDatasetnome.FieldName := 'nome';
    Fs_Prod_SubDepartamentosDatasetnome.Required := True;
    Fs_Prod_SubDepartamentosDatasetnome.Size := 255;
    Fs_Prod_SubDepartamentosDatasetexcluido.SetParentComponent(Fs_Prod_SubDepartamentosDataset);
    Fs_Prod_SubDepartamentosDatasetexcluido.Name := 'Fs_Prod_SubDepartamentosDatasetexcluido';
    Fs_Prod_SubDepartamentosDatasetexcluido.FieldName := 'excluido';
    Fs_Prod_SubDepartamentosDatasetinclusao.SetParentComponent(Fs_Prod_SubDepartamentosDataset);
    Fs_Prod_SubDepartamentosDatasetinclusao.Name := 'Fs_Prod_SubDepartamentosDatasetinclusao';
    Fs_Prod_SubDepartamentosDatasetinclusao.FieldName := 'inclusao';
    Fs_Prod_SubDepartamentosDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_SubDepartamentosDatasetalteracao.SetParentComponent(Fs_Prod_SubDepartamentosDataset);
    Fs_Prod_SubDepartamentosDatasetalteracao.Name := 'Fs_Prod_SubDepartamentosDatasetalteracao';
    Fs_Prod_SubDepartamentosDatasetalteracao.FieldName := 'alteracao';
    Fs_Prod_SubDepartamentosDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_SubDepartamentosDatasetexclusao.SetParentComponent(Fs_Prod_SubDepartamentosDataset);
    Fs_Prod_SubDepartamentosDatasetexclusao.Name := 'Fs_Prod_SubDepartamentosDatasetexclusao';
    Fs_Prod_SubDepartamentosDatasetexclusao.FieldName := 'exclusao';
    Fs_Prod_SubDepartamentosDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    XDataClientFs_Prod_SubDepartamentosGet.SetParentComponent(Self);
    XDataClientFs_Prod_SubDepartamentosGet.Name := 'XDataClientFs_Prod_SubDepartamentosGet';
    XDataClientFs_Prod_SubDepartamentosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientFs_Prod_SubDepartamentosGet, Self, 'OnLoad', 'XDataClientFs_Prod_SubDepartamentosGetLoad');
    XDataClientFs_Prod_SubDepartamentosGet.Left := 64;
    XDataClientFs_Prod_SubDepartamentosGet.Top := 8;
  finally
    lbid.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbExcluido.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Fs_Prod_SubDepartamentosDataset.AfterLoadDFMValues;
    Fs_Prod_SubDepartamentosDatasetid.AfterLoadDFMValues;
    Fs_Prod_SubDepartamentosDatasetnome.AfterLoadDFMValues;
    Fs_Prod_SubDepartamentosDatasetexcluido.AfterLoadDFMValues;
    Fs_Prod_SubDepartamentosDatasetinclusao.AfterLoadDFMValues;
    Fs_Prod_SubDepartamentosDatasetalteracao.AfterLoadDFMValues;
    Fs_Prod_SubDepartamentosDatasetexclusao.AfterLoadDFMValues;
    XDataClientFs_Prod_SubDepartamentosGet.AfterLoadDFMValues;
  end;
end;

end.
